import { z } from 'zod'

const phoneRegex = /^\(\d{2}\)\s\d{4,5}-\d{4}$/

export interface ContactValidationTranslations {
  nameRequired: string
  nameMax: string
  companyRequired: string
  companyMax: string
  emailRequired: string
  emailInvalid: string
  emailMax: string
  phoneRequired: string
  phoneInvalid: string
  phoneMax: string
  subjectRequired: string
  subjectMax: string
  messageRequired: string
  messageMax: string
}

/** Limites alinhados ao backend CreateContactMessageRequest (StringLength) */
export const createContactFormSchema = (messages: ContactValidationTranslations) =>
  z.object({
    name: z
      .string()
      .min(1, messages.nameRequired)
      .max(150, messages.nameMax),
    company: z
      .string()
      .min(1, messages.companyRequired)
      .max(150, messages.companyMax),
    email: z
      .string()
      .min(1, messages.emailRequired)
      .email(messages.emailInvalid)
      .max(150, messages.emailMax),
    phone: z
      .string()
      .min(1, messages.phoneRequired)
      .regex(phoneRegex, messages.phoneInvalid)
      .max(30, messages.phoneMax),
    subject: z
      .string()
      .min(1, messages.subjectRequired)
      .max(200, messages.subjectMax),
    message: z
      .string()
      .min(1, messages.messageRequired)
      .max(4000, messages.messageMax),
  })

export type ContactFormSchema = z.infer<ReturnType<typeof createContactFormSchema>>
